import React, { useState, useEffect, useContext, useMemo } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
// import querystring from 'querystring'; // 已替换为 URLSearchParams
import Context from '../../container';
import Menu from '../Menu';
import DropdownList from '../DropdownList';
import { defaultLanguage, fieldTranslation } from '../constants';
import { getTopNavigation, getMenus } from './services';
import { map, filter, isEmpty } from 'lodash';
import { isSSR } from '../../scripts/utils';
import './index.scss';
import useLanguage from '../../hooks/useLanguage';
import useDeviceInfo from '../../hooks/useDeviceInfo';
import { createContactUsModal } from '../ContactUs';
import Consult from '../IconWrapper/consult';
import MenuIcon from '../IconWrapper/menu';
import MobileMenu from '../MobileMenu';

const menus1688 = [
  { name: '成为采购商', link: '/go1688/purchaser' },
  { name: '成为供应商', link: '/go1688/supplier' }
]

export default function Ceiling() {
  const { dispatch, currentSite = {}, theme, sites = [], host, lang, ...others} = useContext(Context);
  const [menus, setMenus] = useState([]);
  const [displayMenus, setDisplayMenus] = useState([]);
  const { i18n } = useLanguage();
  const [is1688, setIs1688] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const deviceInfo = useDeviceInfo()
  const { bd_vid, ext_info } = deviceInfo
  const afterUrl = useMemo(()=> {
    if (isSSR) return ''; // SSR 时返回空字符串
    const temp = {}
    if (bd_vid) {
      temp.bd_vid = bd_vid
    }
    if (ext_info) {
      temp.ext_info = ext_info
    }
    return isEmpty(temp) ? '' : ('?' + new URLSearchParams(temp).toString())
  }, [bd_vid, ext_info])

  const showContact = () => {
    createContactUsModal();
  };

  useEffect(() => {
    if (isSSR) return;
    
    setTimeout(() => {
      const tempIs1688 = window?.location?.pathname.startsWith('/go1688');
      if (tempIs1688) {
        const path = window?.location?.pathname.replace('/go1688', '') || '/supplier';
        window.location.href = `https://ycx.terminus.io${path}`;
      }
      setIs1688(tempIs1688);
    }, 50);
  }, []);
  // 不统计回传页面访问
  // useEffect(() => {
  //   if (!deviceInfo.bd_vid) {
  //     return
  //   }
  //   const logidUrl = window.location.href
  //   trafficStatic({ ...deviceInfo, logidUrl }).then(() => {
  //     console.log('统计初始化完成: ', logidUrl)
  //   })
  // }, [deviceInfo.deviceId, deviceInfo.deviceType])

  // 判断是否为完整 URL
  const isFullUrl = (url) => url && (url.startsWith('http://') || url.startsWith('https://'));

  // 数据获取函数
  const fetchMenuData = async (siteId) => {
    if (!siteId) {
      return;
    }
    try {
      const topNav = await getTopNavigation({ site: { id: siteId } });
      const result = await getMenus(siteId);
      const _menus = topNav.map((single) => ({
        name: single.displayName,
        link: single.pageAddress
          ? (isFullUrl(single.pageAddress) ? single.pageAddress : single.pageAddress + afterUrl)
          : undefined,
        children: single.pageAddress === '/about-us' ? getAboutUs() : getChild(single, result)
      })).filter(s => s.link !== '/join-us' && s.link !== '/join-us' + afterUrl);
      setMenus(_menus);
      setDisplayMenus(_menus);
      dispatch({ topNav });
    } catch (error) {
      console.error('Failed to fetch menu data:', error);
    }
  };

  // 客户端阶段使用 useEffect 获取数据
  useEffect(() => {
    if (!isSSR && currentSite.id) {
      fetchMenuData(currentSite.id);
    }
  }, [currentSite.id, afterUrl]);

  function onLanguageChange(mark) {
    let target;
    if (mark === defaultLanguage) {
      target = `//${host.replace(`${lang}.`, '')}`;
    } else {
      target = host.indexOf(lang) ? `//${mark}.${host}` : `//${host.replace(lang, mark)}`;
    }
    window.location.href = target;
  }

  const getAboutUs = () => {
    const urlSuffix = !isSSR ? afterUrl : ''; // SSR 时使用空字符串
    return [
      {
        children: [
          {
            name: i18n(fieldTranslation, '新闻动态'),
            link: '/about-us/news' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '品牌活动'),
            link: '/activity' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '公司介绍'),
            link: '/about-us' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '公司刊物'),
            link: '/periodical' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '多媒体资源'),
            link: '/media' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '加入我们'),
            link: '/join-us' + urlSuffix
          },
          {
            name: i18n(fieldTranslation, '联系我们'),
            onClick: showContact
            // link: '/join-us'
          }
        ]
      }
    ];
  };

  function getChild(nav, children) {
    const urlSuffix = !isSSR ? afterUrl : ''; // SSR 时使用空字符串
    let result;
    children.forEach((child) => {
      if (child.title === nav.navigationName) {
        result = filter(
          map(child.data, (d, i) => {
            if (d.productList) {
              return {
                icon: d.proLogo,
                name: d.name,
                desc: d.naviDesc,
                link: d.name === '业务应用' ? `/aip/application` : (d.pageAddress
                  ? (isFullUrl(d.pageAddress) ? d.pageAddress : d.pageAddress + urlSuffix)
                  : (d.pcResource ? (`/product-category/${d.id}` + urlSuffix) : undefined)),
                children:
                  d.productList &&
                  d.productList.map((plate) => ({
                    name: plate.name,
                    desc: plate.naviDesc,
                    link: plate.pageAddress
                      ? (isFullUrl(plate.pageAddress) ? plate.pageAddress : plate.pageAddress + urlSuffix)
                      : (`/product/${plate.id}` + urlSuffix)
                  }))
              };
            } else if (d.solutions) {
              return {
                icon: d.indusIcon,
                name: d.name,
                desc: d.naviDesc,
                link: d.pageAddress
                  ? (isFullUrl(d.pageAddress) ? d.pageAddress : d.pageAddress + urlSuffix)
                  : (`/solution#${i}` + urlSuffix),
                children:
                  d.solutions &&
                  d.solutions.map((solution) => ({
                    name: solution.name,
                    desc: solution.naviDesc,
                    link: solution.pageAddress
                      ? (isFullUrl(solution.pageAddress) ? solution.pageAddress : solution.pageAddress + urlSuffix)
                      : (`/solution/${solution.id}` + urlSuffix)
                  }))
              };
            }
          }),
          (d) => !!d
        );
      }
    });

    return result;
  }

  return (
    <>
      <div
        id="ceiling"
        className={classnames('comp-ceiling hidden-in-mobile', {
          // show: visible,
          // "has-background": hasBackground,
          [theme]: !isSSR ? (is1688 ? false : theme) : theme,
          light: !isSSR ? is1688 : false,
        })}
        suppressHydrationWarning={true}
      >
        <div className="ceiling-main">
          <div className="filter-blur"></div>
          <img className="logo-search" src="/images/logo-all.png" alt="杭州端点网络科技有限公司" />
          <div className="ceiling-content">
            <h1 suppressHydrationWarning={true}>
              <Link to={!isSSR ? (is1688 ? '/go1688' : '/') : '/'} title="杭州端点网络科技有限公司" suppressHydrationWarning={true}>
                <img className="logo-light" src={`/images/${!isSSR && is1688 ? 'logo-1688' : 'logo'}.png`} style={!isSSR && is1688 ? { height: 36, width: 220 } : {}} alt="杭州端点网络科技有限公司" suppressHydrationWarning={true} />
                <img className="logo-dark" src={`/images/${!isSSR && is1688 ? 'logo-1688' : 'logo-dark'}.png`} alt="杭州端点网络科技有限公司" suppressHydrationWarning={true} />
              </Link>
            </h1>
            <div className="ceiling-content-wrapper">
              <Menu className="ceiling-menu" data={!isSSR ? (is1688 ? menus1688 : displayMenus) : []} theme={theme} suppressHydrationWarning={true} />
              {!isSSR && is1688 && <div className='phone-wrap' suppressHydrationWarning={true}>
                <div>
                  <img className='phone-img' src='/images/phone.png' alt="联系方式" />
                  <span className='phone-text'>0571-56131922 / 0571-56131923</span>
                </div>
                <a className='notice-a' target='_blank' href='https://www.aliyun.com/noticelist/articleid/1071134207.html'>
                  <img className='notice-img' src='/images/notice-1688.png' alt="联系方式" />
                </a>
              </div>}
              {(isSSR && sites instanceof Array && sites.length > 1) || (!isSSR && !is1688 && sites instanceof Array && sites.length > 1) ? (
                <span className="lang" suppressHydrationWarning={true}>
                  <DropdownList
                    id="lang-select"
                    options={sites.map((site) => ({
                      icon: site.logo,
                      label: site.title,
                      value: site.mark
                    }))}
                    value={lang}
                    onChange={onLanguageChange}
                  />
                </span>
              ) : null}
            </div>
          </div>
        </div>
        {/* <div onClick={showContact} className="consult-button">
          {lang === 'cn' ? '立即咨询' : 'Consult'}
        </div> */}
      </div>
      <div className="mobile-ceiling hidden-in-pc" suppressHydrationWarning={true}>
        <MenuIcon onClick={() => setMobileMenuOpen(true)} size={20} strokeWidth={1} />
        <MobileMenu
          data={map(displayMenus, (menu) => {
            if (menu.children) {
              return { ...menu, group: true };
            } else {
              return menu;
            }
          })}
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          sites={sites}
          onLanguageChange={onLanguageChange}
        />
        <Link to={"/" + afterUrl} title="杭州端点网络科技有限公司">
          <img
            className="mobile-ceiling-logo"
            src={
              !isSSR && is1688
                ? '/images/logo-1688.png'
                : !isSSR && theme === 'dark'
                  ? '/images/logo-dark.png'
                  : '/images/logo.png'
            }
            alt="杭州端点网络科技有限公司"
          />
        </Link>
        <Consult size={20} strokeWidth={1} onClick={() => createContactUsModal()} />
      </div>
    </>
  );
}
